import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs/internal/BehaviorSubject";
import {AuthService} from "../auth.service";
import {PluginData} from "../../shared/services/plugin-connect/plugin-data";
import {Subject} from "rxjs/internal/Subject";

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  GoogleApple: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  clearCardNumber: Subject<void> = new Subject();

  constructor(
    private _authService: AuthService,
  ) {
  }

  public verifyGoogleToken(
    googleToken: string,
    subscriptionId: string | number,  // Optional subscription ID
    fromPlugin: PluginData | null = null,
    productId: string | number | null = null,
    clientId: string | number | null = null,
    affiliateId: string | null = null,
    signUpFor: object | null = null,
    twoFaToken: string | null = null
  ) {
    return this._authService.proceedWithGoogle(
      googleToken,
      subscriptionId,
      fromPlugin,
      productId,
      clientId,
      affiliateId,
      signUpFor,
      twoFaToken
    );
  }

}
